export enum MetricFormats {
  BOOLEAN = 'boolean',
  FLOAT = 'float',
  NUMBER = 'int',
  MONEY = 'money',
  MONEY_PAYOUT = 'money-payout',
  MONEY_REVENUE = 'money-revenue',
  PERCENTAGE = 'percentage',
  PERCENT = 'percent',
  DATETIME = 'datetime',
}
